// extracted by mini-css-extract-plugin
module.exports = {"regularFontSize":"styles-module__regularFontSize___3KwYk"};